import React from "react";
import AppRoutes from "./routes/Routes";
/* import "./styles/layout.css"; */

function App() {
  return <AppRoutes />;
}

export default App;
